import { AppState, ThunkDispatch } from "redux/store.types";
import { fetchModules } from "services/service/issues/issues.service";
import { fetchBoxes } from "services/service/issues/issues.service";
import { fetchIssues } from "services/service/issues/issues.service";
import { fetchIssuesActivities } from "services/service/issues/issues.service";
import { ViewTypes, Box, Issue, ISSUE_TYPES } from "types/issues.types";
import CONSTANTS from "config/constants";
import { getModule, getModuleByType } from "./issues.reducer.helpers";
import { Worker } from "types/worker.types";
import { fecthSupervisorIssues } from "services/service/issues/issues.service";
import { fetchSupervisorIssuesActivities } from "services/service/issues/issues.service";

export const SET_SERVICE_MODULES = "SET_SERVICE_MODULES";
export const SET_SERVICE_BOXES = "SET_SERVICE_BOXES";
export const SET_SERVICE_SELECTED_MODULE = "SET_SERVICE_SELECTED_MODULE";
export const SET_SERVICE_ORDERBY_VALUE = "SET_SERVICE_ORDERBY_VALUE";
export const SET_SERVICE_SELECTED_BOX = "SET_SERVICE_SELECTED_BOX";
export const SET_SERVICE_VIEW_TYPE = "SET_SERVICE_VIEW_TYPE";
export const SET_SERVICE_ISSUES = "SET_SERVICE_ISSUES";
export const SET_SERVICE_UPDATE_BOX = "SET_SERVICE_UPDATE_BOX";
export const ADD_SERVICE_NEW_BOX = "ADD_SERVICE_NEW_BOX";
export const ADD_SERVICE_NEW_ISSUE = "ADD_SERVICE_NEW_ISSUE";
export const RESET_SERVICE_ISSUES = "RESET_SERVICE_ISSUES";
export const SET_TICKET_SOCKET_CONNECTED = "SET_TICKET_SOCKET_CONNECTED";
export const SET_ORDERBY_VALUE = "SET_ORDERBY_VALUE";
export const SET_ASSIGNEE_TICKETS = "SET_ASSIGNEE_TICKETS";
export const SET_SELECTED_WORKER = "SET_SELECTED_WORKER";
export const SET_DAILY_STATS = "SET_DAILY_STATS";
export const SET_CATEGORY_CODES = "SET_CATEGORY_CODES";

export const SET_DAY_TIMES = "SET_DAY_TIMES";

export const setModules = () => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const { roleId = 1 } = getState().Auth.worker?.additionalInfo ?? {};
  const modules = fetchModules(roleId);
  dispatch({ type: SET_SERVICE_MODULES, payload: modules });
};

export const setBoxes = (moduleId: string) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const issueState = getState().ServiceIssues;
  const { assignee, attributes } = getState().Auth.worker;
  const { categories } = attributes;
  const selectedBoxId = issueState.selectedBoxId;
  const { module } = getModule(issueState, moduleId);
  const boxes = await fetchBoxes(module.type, assignee?.id, categories);
  dispatch({ type: SET_SERVICE_BOXES, payload: { moduleId, boxes } });
  if (!selectedBoxId && boxes?.length) {
    dispatch(setSelectedBox(boxes[0].id, moduleId));
  }
};

export const setBoxesByType = (type: string) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const issueState = getState().ServiceIssues;
  const { assignee, attributes } = getState().Auth.worker;
  const { categories } = attributes;
  const selectedBoxId = issueState.selectedBoxId;
  const { module } = getModuleByType(issueState, type);
  const moduleId = module.id;
  const boxes = await fetchBoxes(module.type, assignee?.id, categories);
  dispatch({ type: SET_SERVICE_BOXES, payload: { moduleId, boxes } });
  if (!selectedBoxId && boxes?.length) {
    dispatch(setSelectedBox(boxes[0].id, moduleId));
  }
};

export const setAssigneeTickets = (payload: any) => (dispatch: Function) => {
  dispatch({ type: SET_ASSIGNEE_TICKETS, payload });
};

export const setSelectedWorker = (payload: Worker) => (dispatch: Function) => {
  dispatch({ type: SET_SELECTED_WORKER, payload });
};

export const setDailyStats = (payload: any) => (dispatch: Function) => {
  dispatch({ type: SET_DAILY_STATS, payload });
};

export const setDayTimes = (payload: any) => (dispatch: Function) => {
  dispatch({ type: SET_DAY_TIMES, payload });
};

export const setCategoryCodes = (payload: string[]) => (dispatch: Function) => {
  dispatch({ type: SET_CATEGORY_CODES, payload });
};

export const setSelectedModule = (moduleId: string) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SERVICE_SELECTED_MODULE, payload: moduleId });
};
export const setOrderBy = (orderBy: string) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_ORDERBY_VALUE, payload: orderBy });
};
export const executeSetOrderBy = (orderBy: string) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const issueState = getState().ServiceIssues;
  const { assignee } = getState().Auth.worker;
  const page = 1;
  const boxId = issueState.selectedBoxId;
  const moduleId = issueState.selectedModuleId;
  const orderBy = issueState.orderBy;
  dispatch(setIssues(page - 1, boxId, moduleId, assignee.id, orderBy));
};
export const executeSearch = (value: string) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const issueState = getState().ServiceIssues;
  const { assignee } = getState().Auth.worker;
  const page = 1;
  const boxId = issueState.selectedBoxId;
  const moduleId = issueState.selectedModuleId;
  const orderBy = issueState.orderBy;
  dispatch(setIssues(page - 1, boxId, moduleId, assignee.id, orderBy, value));
};
export const setSelectedBox = (boxId: string, moduleId: string) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch(setSelectedModule(moduleId));
  dispatch({ type: SET_SERVICE_SELECTED_BOX, payload: boxId });
};

export const setViewType = (viewType: ViewTypes) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SERVICE_VIEW_TYPE, payload: viewType });
};

export const setIssues = (
  page: number,
  boxId: string,
  moduleId: string,
  assigneeId: number,
  orderBy: string,
  valueTosearch?: string
) => async (dispatch: ThunkDispatch, getState: () => AppState) => {
  const pageSize = CONSTANTS.ISSUES.PAGE_SIZE;
  const issueState = getState().ServiceIssues;
  const box = getState().ServiceIssues.selectedBox(issueState);
  const categories = getState().Auth.worker.attributes.categories ?? [];
  const { module } = getModule(issueState, moduleId);
  if (module.type === ISSUE_TYPES.TICKET) {
    const issues = await fetchIssues(
      moduleId,
      boxId,
      page,
      pageSize,
      assigneeId,
      orderBy,
      valueTosearch
    );
    dispatch({
      type: SET_SERVICE_ISSUES,
      payload: { issues, page, boxId, moduleId }
    });
  }
  if (module.type === ISSUE_TYPES.ACTIVITIES) {
    if (!box) {
      return;
    }
    const issues = await fetchIssuesActivities(
      moduleId,
      box,
      page,
      pageSize,
      assigneeId,
      orderBy,
      valueTosearch
    );
    dispatch({
      type: SET_SERVICE_UPDATE_BOX,
      payload: { moduleId, boxId, count: issues.length }
    });
    dispatch({
      type: SET_SERVICE_ISSUES,
      payload: { issues, page, boxId, moduleId }
    });
  }
  if (module.type === ISSUE_TYPES.SUPERVISOR_TICKET) {
    const categoriesCode = categories.join(",");
    const issues = await fecthSupervisorIssues(
      boxId,
      page,
      pageSize,
      categoriesCode,
      orderBy,
      valueTosearch
    );
    dispatch({
      type: SET_SERVICE_ISSUES,
      payload: { issues, page, boxId, moduleId }
    });
  }
  if (module.type === ISSUE_TYPES.SUPERVISOR_ACTIVITIES) {
    if (!box) {
      return;
    }
    const categoriesCode = categories.join(",");
    const issues = await fetchSupervisorIssuesActivities(
      moduleId,
      box,
      page,
      pageSize,
      categoriesCode,
      assigneeId,
      orderBy,
      valueTosearch
    );
    dispatch({
      type: SET_SERVICE_UPDATE_BOX,
      payload: { moduleId, boxId, count: issues.length }
    });
    dispatch({
      type: SET_SERVICE_ISSUES,
      payload: { issues, page, boxId, moduleId }
    });
  }
  if (module.type === ISSUE_TYPES.HISTORY) {
    const issues = await fecthSupervisorIssues(
      boxId,
      page,
      pageSize,
      "",
      orderBy,
      valueTosearch
    );
    dispatch({
      type: SET_SERVICE_ISSUES,
      payload: { issues, page, boxId, moduleId }
    });
  }
};

export const addNewBox = (moduleId: string, box: Box) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: ADD_SERVICE_NEW_BOX, payload: { moduleId, box } });
};

export const addNewIssue = (issue: Issue, boxId: string, moduleId: string) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({
    type: ADD_SERVICE_NEW_ISSUE,
    payload: { issue, boxId, moduleId }
  });
};

export const resetIssues = () => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: RESET_SERVICE_ISSUES });
};

export const setTicketSocketConnected = (isConnected: boolean) => async (
  dispatch: ThunkDispatch
) => {
  dispatch({ type: SET_TICKET_SOCKET_CONNECTED, payload: isConnected });
};
